import interpolate from './interpolate';
function interpolateObject(from, to, k, interpolateMap) {
    if (!from || !to) {
        return to;
    }
    var ret = Object.create(null);
    var interpolator;
    for (var key in from) {
        interpolator = interpolateMap && interpolateMap[key] ? interpolateMap[key] : interpolate;
        ret[key] = interpolator(from[key], to[key], k, interpolateMap);
    }
    return ret;
}
export default interpolateObject;
